export default __webpack_public_path__ + "static/media/piano_4key.287abd60.svg";